import React from "react";

const publications = [
  {
    type: "Paper",
    title:
      "Impact of Instructor Gender on Student Perceptions of Coding Demonstration Videos",
    venue: "ACM ITiCSE 2026 — Paper",
    authors:
      "Deepti Gorrepati, Nevin Ada Çakmak, Zuhal Olomi, Yuseon Jeong, and Brian Harrington",
    year: 2026,
    description: "",
    links: {
      doi: "https://dl.acm.org/doi/10.1145/3803400.3809393",
    },
  },
  {
    type: "Poster",
    title: "Mapping Research on Student Self-Efficacy in Computer Science",
    venue: "ACM ITiCSE 2026 — Poster (first author)",
    authors:
      "Nevin Ada Çakmak, Zuhal Olomi, Arina Azmi, Deepti Gorrepati, Luoyuan Gu, Yuseon Jeong, Maria Motallebi, Kayna Mufidah, Zupaash Naveed, Krushal Rawat, Nihar Samant, Ishika Vithani, and Brian Harrington",
    year: 2026,
    description: "",
    links: {
      doi: "https://dl.acm.org/doi/10.1145/3803401.3812026",
    },
  },
  {
    type: "Poster",
    title:
      "A Systematic Literature Mapping of Gender Bias Towards Instructors in Computer Science Education",
    venue: "ACM ITiCSE 2026 — Poster",
    authors:
      "Zuhal Olomi, Yuseon Jeong, Nevin Ada Çakmak, Deepti Gorrepati, and Brian Harrington",
    year: 2026,
    description: "",
    links: {
      doi: "https://dl.acm.org/doi/10.1145/3803401.3812025",
    },
  },
];
function Publications() {
  return (
    <div id="publications">
      <h1>Publications</h1>

      <div className="projects-container">
        {publications.map((pub, index) => (
          <div className="project-card" key={index}>
            <div className="project-content">
              <h3>{pub.title}{pub.year ? ` (${pub.year})` : ""}</h3>

              <p>
                <strong>{pub.type}</strong> • {pub.venue}
              </p>

              <p>{pub.authors}</p>

              {pub.description && <p>{pub.description}</p>}

              {pub.links && pub.links.doi && (
                <p>
                  <a href={pub.links.doi} target="_blank" rel="noopener noreferrer" className="doi-link">
                    View on ACM Digital Library
                  </a>
                </p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Publications;
